module.exports = __webpack_public_path__ + "static/media/website-resume.08fccd4d.png";